import { createBaseQuery as fetchBaseQuery } from '../baseQuery';
import { baseURL } from '../../../config';
import { createApi } from '@reduxjs/toolkit/query/react';

const baseUrl = `${baseURL}/products/`;

export const productApiService = createApi({
    reducerPath: 'productApi',
    baseQuery: fetchBaseQuery({ baseUrl }),

    endpoints: (builder) => ({
        getProducts: builder.query({
            query: (args = {}) => {
                // Log the arguments passed to the query
          
                // Check if an ID is provided to fetch a specific product
                if (args?.id) {
                    return `/${args.id}`; // Fetch a specific product
                }

                // Construct the query object with only category_id parameter
                const query = {
                    page: args.page || 1, // Default to page 1 if not provided
                    rowsPerPage: args.rowsPerPage || 9, // Default to 9 if not provided
                    search: args.search || '',
                    sortBy: args.sortBy || '',
                    category_id: args.category_id || '',
                    minPrice: args.minPrice ?? '',
                    maxPrice: args.maxPrice ?? '',
                };

                // Log the constructed query parameters
             

                // Return the endpoint with query parameters as an object
                return {
                    url: '/',
                    params: query,
                };
            },
            keepUnusedDataFor: 0,
        }),
        getRandom: builder.query({
            query: () => {
                // Return the endpoint for fetching recommended products with static limit
                return 'recommended?limit=3';
            },
            keepUnusedDataFor: 0,
        }),
        getSearchSuggestions: builder.query({
            query: (query) => {
                // Return the endpoint for search suggestions
                return {
                    url: 'search/suggestions',
                    params: { query },
                };
            },
            keepUnusedDataFor: 0,
        }),
        getSingleProduct: builder.query({
            query: (id) => {
                // Return the endpoint for fetching a single product by ID
                return `${id}`;
            },
            keepUnusedDataFor: 0,
        }),
        getRandomProducts: builder.query({
            query: (timestamp) => {
                // Use timestamp to force fresh data on each call
                return `random?t=${timestamp || Date.now()}`;
            },
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
    }),
});

export const {
    useGetProductsQuery,
    useGetRandomQuery, // Fixed this to follow the naming convention
    useGetSearchSuggestionsQuery,
    useGetSingleProductQuery,
    useGetRandomProductsQuery, // New hook for random products API
} = productApiService;
